import Alpine from 'alpinejs';
import axios from 'axios';

Alpine.data('callBack', () => ({
  name: '',
  phone: '',
  zip: '',
  city: '',
  jobPreference: '',
  email: '',
  timeFrom: '08:00',
  timeTo: '17:00',
  privacy: false,
  showCallBack: false,
  showCallBackSuccess: false,
  isTimeFromOpen: false,
  isTimeToOpen: false,
  showCallBackButton: true,
  errors: {
    name: false,
    phone: false,
    zip: false,
    city: false,
    jobPreference: false,
    email: false,
    privacy: false,
  },

  showCallBackModal(event) {
    event.preventDefault();
    this.showCallBack = true;
    this.showCallBackButton = false;
    const popups = document.querySelectorAll('.call-back-wrapper');

    // Function to check the position and add the class if necessary
    const checkPositionAndAddClass = (popup) => {
      const rect = popup.getBoundingClientRect();
      const distanceFromBottom = window.innerHeight - rect.bottom;

      if (distanceFromBottom < 200) {
        popup.classList.add('adjusted-bottom');
      }
    };

    // Create a MutationObserver to observe changes in the style attribute
    const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const popup = mutation.target;
          const display = popup.style.display;

          if (display !== 'none' && display !== '') {
            // Wait for the next frame to ensure the popup is rendered
            requestAnimationFrame(() => checkPositionAndAddClass(popup));
          }
        }
      }
    });

    // Observe each popup for attribute changes
    popups.forEach(popup => {
      observer.observe(popup, { attributes: true });
    });

   /* window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); */
  },

  closeCallBackModal() {
    this.showCallBack = false;
    this.showCallBackSuccess = false;
    this.name = '';
    this.phone = '';
    this.zip = '';
    this.city = '';
    this.jobPreference = '';
    this.email = ''
    this.timeFrom = '08:00';
    this.timeTo = '17:00';
    this.privacy = false;
    this.showCallBackButton = true;
  },

  openTimeFromDropdown() {
    this.isTimeFromOpen = true;
  },

  selectTimeFrom(elm) {
    this.timeFrom = elm.dataset.value;
    this.isTimeFromOpen = false;
  },

  openTimeToDropdown() {
    this.isTimeToOpen = true;
  },

  selectTimeTo(elm) {
    this.timeTo = elm.dataset.value;
    this.isTimeToOpen = false;
  },

  validateZip(value) {
    const regex = new RegExp(/^\d+$/);
    if(!regex.test(value)) {
      this.errors.zip = true;
      return
    } else {
      this.errors.zip = false;
    }
  },

  validatePhone(value) {
    const regex =  new RegExp(/^[\d\/+ ]*$/);
    if(!regex.test(value)) {
      this.errors.phone = true;
      return;
    } else {
      this.errors.phone = false;
    }
  },

  validateEmail(value) {
    const regex =  new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);
    if(!regex.test(value)) {
      this.errors.email = true;
      return;
    } else {
      this.errors.email = false;
    }
  },

  submitCallBack(elm) {
    const { submitUrl } = elm.dataset;

    if (this.name.length === 0) {
      this.errors.name = true;
    } else {
      this.errors.name = false;
    }
    if (this.phone.length === 0) {
      this.errors.phone = true;
    } else {
      this.validatePhone(this.phone);
    }

    if (this.email.length === 0) {
      this.errors.email = true;
    } else {
      this.validateEmail(this.email);
    }

    if(this.zip.length === 0) {
      this.errors.zip = true
    } else {
      this.validateZip(this.zip);
    }
    if(this.city.length === 0) {
      this.errors.city = true
    } else {
      this.errors.city = false
    }
    if (this.jobPreference.length === 0) {
      this.errors.jobPreference = true;
    } else {
      this.errors.jobPreference = false;
    }
    if (!this.privacy) {
      this.errors.privacy = true;
    } else {
      this.errors.privacy = false;
    }

    if (!Object.values(this.errors).find(value => value)) {
      // submit
      const postData = {
        webform_id: 'call_back',
        name: this.name,
        phone: { phone: this.phone },
        email: this.email,
        address: {postal_code: this.zip, city: this.city},
        zip: this.zip,
        city: this.city,
        jobpreference: this.jobPreference,
        timefrom: this.timeFrom,
        timeto: this.timeTo,
        privacy: this.privacy,
      };

      axios({
        method: 'GET',
        url: `/session/token`,
        headers: {
          Accept: 'application/vnd.api+json',
        },
      })
        .then(response => response)
        .then(token => {
          const headers = {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': token.data,
          };
          axios
            .post(submitUrl, postData, {
              headers: headers,
            })
            .then(response => {
              this.showCallBack = false;
              this.showCallBackSuccess = true;
            })
            .catch(err => {
              console.warn(err);
              // only for testing
              this.showCallBack = false;
              this.showCallBackSuccess = true;
            });
        });
    }
  },
}));
